export interface INamedEntity {
    id: string;
    name: string;
    [key: string]: unknown;
}

function hasAlwaysDisplayFlag<T extends INamedEntity>(entity: T): entity is T & { shouldDisplayCreateNewUserGroupFields: boolean } {
    return 'shouldDisplayCreateNewUserGroupFields' in entity &&
        !!(entity as { shouldDisplayCreateNewUserGroupFields?: boolean }).shouldDisplayCreateNewUserGroupFields;
}

export const filterHelper = <T extends INamedEntity>(
    options: T[],
    state: { inputValue: string },
    filterFunction: ((entity: T, input: string) => boolean) | null = null
): T[] => {
    const filteredOptions = options.filter(opt => {
        if (!opt.id) {
            return true;
        }
        const filterInput = state.inputValue.trim();
        if (filterFunction) {
            return filterFunction(opt, filterInput);
        }
        return opt.name.toLowerCase().includes(filterInput.toLowerCase());
    });

    if (filteredOptions.length === 1) {
        const singleOption = filteredOptions[0];
        if (hasAlwaysDisplayFlag(singleOption)) {
            return filteredOptions;
        }

        if (!singleOption.name) {
            return [];
        }
    }

    return filteredOptions;
};

export const bindFilterHelper = <T extends INamedEntity>(filterFunction: (entity: T, input: string) => boolean) => {
    return (options: T[], state: { inputValue: string }) => filterHelper(options, state, filterFunction);
};

export const isOptionEqualToValueDefaultCallback = <T extends INamedEntity>(option: T, value: T): boolean => {
    return option.id === value.id;
};

export const getOptionLabelDefaultCallback = <T extends INamedEntity>(option: T): string => {
    return option.name || '';
};
